import { isPlatformAXA } from 'utils/showDetails';

import {
  AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS,
  AXA_DIVIDEND_BOUNCE_OPERATION_ID,
  ENABLE_AXA_DIVIDEND_BOUNCE_RETRY,
} from '../constants/axaDividendBounceAllowedEmails';

export const isAxaDividendBounceRetryActive = (operationId?: string): boolean =>
  Boolean(
    isPlatformAXA &&
      ENABLE_AXA_DIVIDEND_BOUNCE_RETRY &&
      operationId &&
      AXA_DIVIDEND_BOUNCE_OPERATION_ID &&
      String(AXA_DIVIDEND_BOUNCE_OPERATION_ID) === String(operationId) &&
      AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS.length
  );

export const getAxaDividendBounceAllowedEmails = (): string[] =>
  AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS;
